module.exports = __webpack_public_path__ + "static/contact-934468947e46d1df816b114cb572a6c6.svg";